import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from 'react-visibility-sensor';

import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';

import swiperImg1 from "../../../assets/img/home/hero/swiperImg1.webp";
import swiperImg2 from "../../../assets/img/home/hero/swiperImg2.webp";
import swiperImg3 from "../../../assets/img/home/hero/swiperImg3.webp";

import arrow from "../../../assets/img/components/buttonBlue.webp";
import arrow2 from "../../../assets/img/components/buttonBlue2.webp";
import arrow3 from "../../../assets/img/components/buttonBlue3.webp";

function HomeHero(){
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <section>
            <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
                <div className="homeHeroBg">
                    <div className="homeHero">
                        <Swiper
                            allowTouchMove= {false}
                            className="mySwiper swiperText"
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            speed={1200}
                            loop
                            breakpoints={{
                                0:{
                                    direction: "horizontal"
                                },
                                769: {
                                    direction: "vertical",
                                },
                            }}
                        >
                            <SwiperSlide><h1 className={`${isVisible ? 'visible' : ''}`}>{t("hero_slide1")}</h1></SwiperSlide>
                            <SwiperSlide><h1 className={`${isVisible ? 'visible' : ''}`}>{t("hero_slide2")}</h1></SwiperSlide>
                            <SwiperSlide>
                                <h1 className={`${isVisible ? 'visible' : ''}`}>
                                    <span style={{color: 'var(--cor-secondary)', fontWeight: '700'}}>
                                        {t("hero_slide3.1")} <br />
                                    </span>
                                    {t("hero_slide3.2")} <br />
                                    {t("hero_slide3.3")} <br />
                                </h1>
                            </SwiperSlide>
                        </Swiper>
                        <Swiper
                            allowTouchMove= {false}
                            direction={'vertical'}
                            className="mySwiper swiperImg"
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            speed={1200}
                            loop
                            breakpoints={{
                                0:{
                                    direction: "horizontal"
                                },
                                769: {
                                    direction: "vertical",
                                },
                            }}
                        >
                            <SwiperSlide><img className={`${isVisible ? 'visible' : ''}`} src={swiperImg1} alt="" width={'550px'} height={'500px'} /></SwiperSlide>
                            <SwiperSlide><img className={`${isVisible ? 'visible' : ''}`} src={swiperImg2} alt="" width={'550px'} height={'500px'} /></SwiperSlide>
                            <SwiperSlide><img className={`${isVisible ? 'visible' : ''}`} src={swiperImg3} alt="" width={'550px'} height={'500px'} /></SwiperSlide>
                        </Swiper>
                    </div>
                    <img className={`arrow1 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
                    <img className={`arrow2 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
                    <img className={`arrow3 ${isVisible ? 'visible' : ''}`} src={arrow3} alt="" />
                    <img className={`arrow4 ${isVisible ? 'visible' : ''}`} src={arrow3} alt="" />
                    <img className={`arrow5 ${isVisible ? 'visible' : ''}`}  src={arrow2} width={'100px'} alt="" />
                    <img className={`arrow6 ${isVisible ? 'visible' : ''}`} src={arrow2} width={'100px'} alt="" />
                    <img className={`arrow7 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
                    <img className={`arrow8 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
                </div>
            </VisibilitySensor>
        </section>
    )
}

export default HomeHero;